// Light-themed hover tooltip with a downward arrow that sits above its
// trigger. Built on the library Popover so it portals out of the DOM and is
// never clipped by a parent's overflow (e.g. the posting modal).
import { Box, Popover } from '@atgfr8/atg-ui-tailwind';
import { formatDataTestId } from '@utils/dataTestIdFormatter';
import { createSignal, JSXElement, mergeProps } from 'solid-js';

interface HintTooltipProps {
  text: string;
  width?: number;
  children: JSXElement;
}

const HintTooltip = (props: HintTooltipProps) => {
  const mp = mergeProps({ width: 260 }, props);
  const [anchorEl, setAnchorEl] = createSignal<HTMLDivElement>();
  const [open, setOpen] = createSignal(false);

  return (
    <Box
      ref={setAnchorEl}
      class="inline-flex items-center"
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
    >
      {mp.children}
      <Popover
        dataTestId={formatDataTestId(mp.text, 'div')}
        open={open()}
        anchorEl={anchorEl()}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        transformOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        onClose={() => setOpen(false)}
        disableRestoreFocus
        sx={{ 'pointer-events': 'none' }}
        PaperProps={{
          sx: {
            overflow: 'visible',
            'margin-top': '-8px',
            'border-radius': '8px',
            border: '1px solid rgba(0, 0, 0, 0.12)',
            'box-shadow': '0 2px 8px rgba(0, 0, 0, 0.15)',
          },
        }}
      >
        <Box
          style={{
            position: 'relative',
            width: `${mp.width}px`,
            padding: '8px 12px',
            color: 'rgba(0, 0, 0, 0.87)',
            'font-size': '14px',
            'line-height': '1.35',
            'text-align': 'left',
          }}
        >
          {mp.text}
          <span
            style={{
              position: 'absolute',
              top: '100%',
              left: '50%',
              width: '10px',
              height: '10px',
              transform: 'translate(-50%, -50%) rotate(45deg)',
              background: '#ffffff',
              'border-right': '1px solid rgba(0, 0, 0, 0.12)',
              'border-bottom': '1px solid rgba(0, 0, 0, 0.12)',
            }}
          />
        </Box>
      </Popover>
    </Box>
  );
};

export default HintTooltip;
